module.exports = __webpack_public_path__ + "static/media/playActive.969ba390.svg";